// Unit Management Permissions

export const UNITS_INDEX = 17;
export const UNITS_SHOW = UNITS_INDEX;
export const UNITS_CREATE = 18;
export const UNITS_EDIT = 19;
export const UNITS_DELETE = 20;

// Unit Detail Views
export const UNITS_VIEW_CONTRACTS = 117;
export const UNITS_VIEW_INVOICES = 118;
export const UNITS_VIEW_DUES = 119;
export const UNITS_VIEW_TIMELINE = 120;
export const UNITS_VIEW_SERVICES = 121;
export const UNITS_PROMOTIONS = 122;

export const UNITS_ASSIGN_EQUIPMENTS = 1221;
export const MARKETPLACE_LISTINGS_VIEW = 1222;
export const UNIT_VIEW_STATS = 1223;

export const UNITS_CLONE = 1215;

export const UNITS_RESTORE = 1377;
